(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Traitify", [], factory);
	else if(typeof exports === 'object')
		exports["Traitify"] = factory();
	else
		root["Traitify"] = factory();
})(this, function() {
return 